module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADkSURBVHgBjZA7CsJAGIRn45pCISxiYmMRb+ARxN7OXrGw9gYRG0tvoEew8CB2WmiIhZ2FEtRGye9mSSAvJAPLPv75ZmCBApFnrsi1tigjae6Sa5Jap2YvO9dyRIDtYt3AdGkBFeb8BehsjuVmHzwd/luOCL1sS7qBQSUa9QBGLYgcbFMIxOkKkOYQimST25qlADoKO06PG9rWN5EbOLQXIjxxddf1kcTseDwZ+MhIwOBhy5ypdL3qJafrnaFahv1n8vkB/9Ph0pz7Ov+l4XrjBS1Vh5HbvMvvESinC4f27Si6nB4/uuNI+7KDBGUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/warning.png
// module id = lk7M
// module chunks = 46